import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './index.less';
import { FAEOrderStatusItem, FAESearchForm } from '@/types/technical';
import SearchFormSelectBtn from '../SearchFormSelectBtn';
import { Button, DatePicker, Form, Input } from 'antd';
import { getFAEOrderStatusList } from '@/api/technical';

interface SearchFormProps {
  // Define your props here
  onSubmit?: (values: any,isSearch?: boolean) => void;
}

const prefix = 'search-form';

const initTimeRange: FAESearchForm['timeRange'] = {
  startTime: '',
  endTime: ''
}
const initForm: FAESearchForm = {
  status: '',
  timeRangeType: null,
  timeRange: initTimeRange,
  keywordOrSn: ''
}

const SearchForm = forwardRef((props:SearchFormProps,ref) => {
  const { onSubmit } = props;
  console.log('SearchForm render');

  useImperativeHandle(ref, () =>{
    return {
      getSearch(){
        return searchForm;
      }
    }
  })
  /**
   * 工单状态
   */
  const [orderStatus, setOrderStatus] = useState<FAEOrderStatusItem[]>([{
    id: '',
    name: "全部",
  }]);
/**
 * 时间选项
 */
  const [timerSelectList, setTimerSelectList] = useState<FAEOrderStatusItem[]>([
    {
      id: null,
      name: "所有问题",
    },
    {
      id: 'currentDay',
      name: "今日",
    },
    {
      id: 'lastDay1',
      name: "昨日",
    },
    {
      id: 'lastDay7',
      name: "最近7天",
    }
  ]);
  const [searchForm, setSearchForm] = useState<FAESearchForm>(initForm);
  const timeRangeValue =useRef<any>([null,null]);

  const getOrderStatus= useCallback(
    /**
     * 获取工单状态
     */
    () => {
    getFAEOrderStatusList<FAEOrderStatusItem[]>().then((res) => {
      console.log('getOrderStatus res', res);
      if(res.code==200){
        setOrderStatus(res.result.map((item)=>{
          return {
            id: item.code || '',
            name: item.name,
            count: item.count
          }
        }))
      }
    }).catch((err) => {
      console.log('getOrderStatus err', err);
    })
  },[])
  /**
   * 状态变更事件
   */
  const changeSearchFormValue = useCallback((value: any, field: keyof FAESearchForm) => {
    console.log('changeSearchFormValue', value, field);
    setSearchForm((v) => ({
      ...v,
      [field]: value,
    })
    );
  }, []);
  const timeRangeTypeChangeHandle = useCallback((value: any)=>{
    changeSearchFormValue(initTimeRange, 'timeRange');
    //timeRange 和 timeRangeType 只能有一个有值
    timeRangeValue.current = [null, null];
    changeSearchFormValue(value, 'timeRangeType');
  },[])
  const statusChangeHandle = useCallback((value: any)=>{
    changeSearchFormValue(value, 'status')
  },[])
  const searchInputChangeHandle = useCallback(
    /**
     * 输入框搜索事件
     * @param e 
     */
    (e: React.ChangeEvent<HTMLInputElement>) => {
      changeSearchFormValue(e.target.value, 'keywordOrSn')
    }, [])

  const onRangePickerChange = useCallback(
    /**
     * 日期变更处理
     * @param value 
     * @param date 
     */
    (value: any, date: any) => {
      console.log('onRangePickerChange', date,value);
      timeRangeValue.current = value;
      changeSearchFormValue({
        startTime: (value && new Date(value[0]).getTime()) || '',
        endTime:(value && new Date(value[1]).getTime()) || ''
      }, 'timeRange')
      changeSearchFormValue(value?'customize':null, 'timeRangeType')
    }, []);

  const onSubmitHandle = useCallback(
    /**
     * 提交表单
     */
    () => {
      console.log('onSubmitHandle', searchForm);
      onSubmit && onSubmit(searchForm);
    }, [searchForm])

  const clearSearchForm = useCallback(
    /**
     * 清空表单
     */
    () => {
      const form={...initForm};
      setSearchForm(form);
      timeRangeValue.current = [null, null];
      onSubmit && onSubmit(form,true);
    }, [])

    useEffect(()=>{
      getOrderStatus();
    },[])
  return (
    <Form onFinish={onSubmitHandle}>
      <div className={`${prefix}`}>
        <div className={`${prefix}-box`}>
          <div className={`${prefix}-box-left`}>
            <SearchFormSelectBtn
              btns={timerSelectList}
              selectId={searchForm.timeRangeType}
              onclickHandle={timeRangeTypeChangeHandle}
            />
            <div className={`questions-right-search-input ${prefix}-input`} >
              <DatePicker.RangePicker
                popupClassName='common-range-picker'
                value={timeRangeValue.current}
                needConfirm={false}
                onChange={onRangePickerChange}
              />
              <Input
                maxLength={64}
                value={searchForm.keywordOrSn}
                placeholder="请输入服务单号或者关键词"
                onChange={searchInputChangeHandle}
              />
            </div>
          </div>
          <div className="questions-right-search-btn">
            <Button type="primary" htmlType="submit">搜索</Button>
            <Button onClick={clearSearchForm}>清空</Button>
          </div>
        </div>
        <div className={`${prefix}-box`}>
          <div className={`${prefix}-box-left`}>
            <SearchFormSelectBtn
              btns={orderStatus}
              selectId={searchForm.status}
              onclickHandle={statusChangeHandle}
            />
          </div>
        </div>
      </div>
    </Form>
  );
});
SearchForm.displayName = 'SearchForm';
export default React.memo(SearchForm);
